import { render, staticRenderFns } from "./HomeFeedGuideline.vue?vue&type=template&id=d068db62&scoped=true"
import script from "./HomeFeedGuideline.vue?vue&type=script&lang=js"
export * from "./HomeFeedGuideline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d068db62",
  null
  
)

export default component.exports